<template>
  <div class="recharge-type-tabs" :class="{ compact }" role="tablist" aria-label="Top-up currency">
    <button
      v-for="tab in tabs"
      :key="tab.value"
      type="button"
      role="tab"
      class="recharge-type-tab"
      :class="{ active: active === tab.value }"
      :aria-selected="active === tab.value"
      @click="switchType(tab.value)"
    >
      {{ tab.label }}
    </button>
  </div>
</template>

<script setup>
const props = defineProps({
  active: {
    type: String,
    required: true,
    validator: value => ['coins', 'gems'].includes(value),
  },
  compact: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['change'])
const tabs = [
  { label: 'Coins', value: 'coins' },
  { label: 'Gems', value: 'gems' },
]

function switchType(value) {
  if (value !== props.active) emit('change', value)
}
</script>

<style lang="scss" scoped>
.recharge-type-tabs {
  width: 326px;
  height: 54px;
  padding: 3px;
  display: grid;
  grid-template-columns: repeat(2, 160px);
  border-radius: 27px;
  background: #f1f1f1;
  box-sizing: border-box;
}

.recharge-type-tab {
  width: 160px;
  height: 48px;
  padding: 0;
  border: 0;
  outline: none;
  border-radius: 24px;
  color: #999999;
  background: transparent;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: 0;
  text-align: center;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;

  &.active {
    color: #ffffff;
    background: linear-gradient(90deg, #ff41ff 0%, #6922ff 100%);
    cursor: default;
  }
}

.recharge-type-tabs.compact {
  width: 260.8px;
  height: 43.2px;
  padding: 2.4px;
  grid-template-columns: repeat(2, 128px);
  border-radius: 21.6px;

  .recharge-type-tab {
    width: 128px;
    height: 38.4px;
    border-radius: 19.2px;
    font-size: 12.8px;
    line-height: 100%;
  }
}
</style>
